document.addEventListener('DOMContentLoaded', function () {

    //find the header search element
    const searchContainer = document.querySelector('.header-search');

    //if we have a header search element
    if(searchContainer) {

        //find the input within it
        const input = searchContainer.querySelector('input');

        //find the button within it
        const button = searchContainer.querySelector('button');

        //if we have an input and a search button
        if(input && button) {

            //define a function to update the active class based on focus and input
            function updateActiveClass() {

                //if the active element is the input...
                if (document.activeElement === input) {

                    //add the active class to the search container
                    searchContainer.classList.add('active');
                } else if(input.value.trim() === '') { //otherwise if the input is empty...

                    //remove the active class from the search container
                    searchContainer.classList.remove('active');
                }
            }

            //add an event listener for input changes
            input.addEventListener('focus', updateActiveClass);
            input.addEventListener('blur', updateActiveClass);

            //add a focus listener to the button too
            button.addEventListener('focus', updateActiveClass);

            //add an event listener for clicks on the button
            button.addEventListener('click', function (event) {

                //if the window width is less than 1536px, the input is empty and the class 'active' is not present
                if (window.innerWidth < 1536 && input.value.trim() === '' && !searchContainer.classList.contains('active')) {

                    //prevent the default action
                    event.preventDefault();

                    //add the active class to the search container
                    searchContainer.classList.add('active');

                    //focus the input
                    input.focus();
                }
            });
        }
    }
});